import React, { useEffect, useState } from "react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { Player } from "video-react";
import { IP } from "../../../../internalServer";

export default function SubmisshionByUpload({ response, questionNo }) {
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const [isClicked, setIsClicked] = useState(false);
  const [answerLimit, setAnswerLimit] = useState(
    response?.question_response?.question?.type?.max_limit ? Number(response?.question_response?.question?.type?.max_limit) : 2500
  );

  useEffect(() => {
    setAnswerLimit(Number(response?.question_response?.question?.type?.max_limit));
  }, [response?.question_response?.question?.type]);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. &nbsp;
            {/* {response?.question_response?.question?.title ?? response?.question_response?.b4sQuestion?.title} */}
            {response?.question_response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue ">
            {response?.question_response?.question?.correct_score} Marks
          </div> */}
        </div>
        {response?.question_response?.question?.attachments?.length > 0 &&
          response?.question_response?.question?.attachments?.map(
            (attachment, index) => (
              <div key={index}>
                {attachment.match(/\.(.*?)$/)?.[1] !== "mp4" ? (
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment.split(".").pop() === "JPEG" ||
                      attachment.split(".").pop() === "JPG" ||
                      attachment.split(".").pop() === "PNG" ||
                      attachment.split(".").pop() === "png" ? (
                      <img
                        style={{ cursor: "pointer" }}
                        className="mt-3 imageWidthAndHeight"
                        src={IP + attachment?.replace(/^\./, "")}
                        alt="Attachment"
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                      />
                    ) : (
                      <div
                        key={index}
                        onClick={(e) => {
                          if (attachment.split(".").pop() === "mp3") {
                            handleClick(attachment);
                          } else {
                            setPedingSubDetail({
                              ...pedingSubDetail,
                              pdfView: true,
                              attachment: attachment,
                            });
                          }
                        }}
                        className="mt-2"
                      >
                        <div className="d-flex pdfContainer gap-2 p-2 ">
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div className="w-100">
                            <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize">12 KB</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex pdfContainer gap-2 p-2 "
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}>
                    <div className="d-flex align-items-center">
                      <img
                        className="extention_icon"
                        src={`${iconData?.find(
                          (i) =>
                            i.extension ===
                            attachment?.match(/\.([^.]+)$/)[1]
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                    <div className="w-100">
                      <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                        {attachment?.replace(/^[^_]*_/, "")}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}
              </div>
            )
          )
        }
        <div className="yourAnswerTextArea mt-3">Your answer</div>

        <div>
          {response?.question_response?.descriptive_answer && (
            <div style={{ position: "relative" }} className="mt-3 mb-3">
              <textarea
                placeholder="Type to write your answer here."
                className="textInputQuestion p-3"
                maxLength={answerLimit}
                value={response?.question_response?.descriptive_answer}
              ></textarea>
              <div
                className="maxWordCount"
                style={{
                  position: "absolute",
                  bottom: "10px",
                  right: "10px",
                }}
              >
                {response?.question_response?.descriptive_answer?.length}/{answerLimit}
              </div>
            </div>
          )}
          {response?.question_response?.attachments?.length > 0 ? (
            <div className="d-flex gap-4 flex-wrap ">
              {response?.question_response?.attachments?.map(
                (attachment, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}
                    className="mt-2"
                  >
                    <div className="d-flex pdfContainer gap-2 p-2 ">
                      <div className="d-flex align-items-center">
                        <img
                          className="extention_icon"
                          src={`${iconData?.find(
                            (i) =>
                              i.extension ===
                              attachment?.match(/\.([^.]+)$/)[1]
                          )?.icon
                            }`}
                          alt=""
                        />
                      </div>
                      <div className="w-100">
                        <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                          {attachment?.replace(/^[^_]*_/, "")}
                        </div>
                        <div className="pdfFileSize">12 KB</div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          ) : (
            <div>
              {
                !response?.question_response?.descriptive_answer && <span>No Answers</span>
              }
            </div>
          )}
        </div>
        <div className="mt-4 ">
          <div className="TeacherRemarkHeader">TEACHER’S REMARK</div>
          {response?.comment ? (
            <div className="TeacerRemarkText mt-2">{response?.comment}</div>
          ) : (
            <span className="mt-2">No Remarks</span>
          )}
        </div>
        {response?.question_response?.question?.correct_answers?.length > 0 &&
          response?.question_response?.question?.correct_answers?.map((correctAnswer, index) => {
            const explanation = correctAnswer?.reason_for_answer?.explanation;
            return (
              <>
                <div className="TeacherRemarkHeader mt-2">CORRECT ANSWER</div>
                {explanation ? (
                  <div className="TeacerRemarkText mt-2">{explanation}</div>
                ) : (
                  <div className="TeacerRemarkText mt-2">No Explanation</div>
                )}
              </>
            );
          })}

        <div className="d-flex gap-4 flex-wrap ">
          {response?.question_response?.question?.correct_answers?.length > 0 &&
            response?.question_response?.question?.correct_answers?.map((correctAnswer, index) => {
              const attachment = correctAnswer?.reason_for_answer?.attachment;
              if (!attachment) return null;
              const fileExtension = attachment.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "mp4"].includes(fileExtension);

              return isImage ? (
                <img
                  key={index}
                  style={{ cursor: "pointer" }}
                  className="mt-3 imageWidthAndHeight"
                  src={IP + attachment.replace(/^\./, "")}
                  alt="Attachment"
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}
                />
              ) : (
                <div
                  key={index}
                  onClick={() =>
                    setPedingSubDetail({
                      ...pedingSubDetail,
                      pdfView: true,
                      attachment: attachment,
                    })
                  }
                  className="mt-2"
                >
                  <div className="d-flex pdfContainer gap-2 p-2">
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          iconData?.find((i) => i.extension === fileExtension)?.icon || "default-icon.png"
                        }
                        alt="File Icon"
                        className="extention_icon"
                      />
                    </div>
                    <div className="w-100">
                      <div className="pdfName">{attachment.replace(/^[^_]*_/, "")}</div>
                      <div className="pdfFileSize"></div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
